import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthLayout } from '@/features/auth/components/auth-layout/AuthLayout';
import { VerifyEmailPage } from '@/features/auth/pages/verify-email-page/VerifyEmailPage';

const RouteComponent = () => {
  const { email } = Route.useSearch();
  return (
    <AuthLayout>
      <VerifyEmailPage email={email} />
    </AuthLayout>
  );
};

export const Route = createFileRoute('/verify-email')({
  validateSearch: z.object({
    email: z.string().optional(),
  }),
  component: RouteComponent,
});
